import basicmodal from "../basicmodal";
import toggleHidden from "../../helpers/toggle-hidden";

const bankerSearchWithFilter = (createModal) => {
  const listEl = document.getElementById("bankergrid");
  const templateEl = document.getElementById("bankercardtemplate");
  const paginationEl = document.getElementById("bankerspagination");
  const nextEl = document.getElementById("bankersnext");

  const filterContainerEl = document.querySelector(
    "[data-js=bankersearchfilter]"
  );

  const hiddenFilterEls = document.querySelectorAll(
    "input.bankergrid-hidden-filter"
  );
  const filterEls = filterContainerEl.querySelectorAll("input, select");
  const selectEls = filterContainerEl.querySelectorAll("select");
  const optionEls = filterContainerEl.querySelectorAll("select option");
  const inputEl = document.getElementById("search-name");
  const buttonEls = filterContainerEl.querySelectorAll("button.search-term");
  const submitBtnEl = document.getElementById("searchsubmit");

  const countGrammar = document.getElementById("bankergrid-results-grammar");
  const filtersList = document.querySelector(".bankergrid-filters-list");
  const resultsBanner = document.querySelector(".bankergrid-results-banner");
  const resultsTotal = document.getElementById("bankergrid-results-total");

  // when clicking duplicate dropdown, select native option from hidden select
  for (let i = buttonEls.length - 1; i >= 0; i -= 1) {
    const buttonEl = buttonEls[i];

    buttonEl.addEventListener("click", (event) => {
      event.preventDefault();
      const buttonVal = buttonEl.value;

      for (let j = optionEls.length - 1; j >= 0; j -= 1) {
        if (optionEls[j].value === buttonVal) {
          optionEls[j].selected = "selected";

          break;
        }
      }
    });
  }

  const getFilterSettings = (pageIndex) => {
    const filter_data = [`page=${pageIndex}`];

    for (let k = filterEls.length - 1; k >= 0; k -= 1) {
      const name = filterEls[k].getAttribute("name");

      if (filterEls[k].value.lastIndexOf(999999, 0) === 0) {
        filterEls[k].value = "";
      } else {
        filter_data.push(`${name}=${filterEls[k].value}`);
      }
    }

    for (let l = hiddenFilterEls.length - 1; l >= 0; l -= 1) {
      const name = hiddenFilterEls[l].getAttribute("name");
      filter_data.push(`${name}=${hiddenFilterEls[l].value}`);
    }
    return filter_data.join("&");
  };

  const outputItems = (data) => {
    const totalItems = data.totalItems;
    const totalPages = Number(data.pagination.totalPages);
    const currentPage = Number(data.pagination.currentPage) + 1;
    nextEl.value = data.pagination.nextPage;

    resultsTotal.innerHTML = totalItems;

    if (totalItems === 1) {
      countGrammar.innerHTML = "banker";
    } else {
      countGrammar.innerHTML = "bankers";
    }

    if (filtersList.innerHTML === "") {
      resultsBanner.style.display = "none";
    } else {
      resultsBanner.style.display = "block";
    }

    toggleHidden(paginationEl, data.pagination !== false);
    toggleHidden(nextEl, data.pagination.nextPage !== false);

    if (currentPage === totalPages || currentPage > totalPages) {
      toggleHidden(paginationEl, data.pagination === false);
      toggleHidden(nextEl, data.pagination.nextPage === false);
    }

    if (data.pagination.currentPage === 0) {
      listEl.innerHTML = "";
    }

    for (let m = 0; m < data.items.length; m += 1) {
      const item = data.items[m];

      console.log("wpro_debug__item__object");
      console.log({ wpro_debug__item__object: item });
      const liEl = document.createElement("div");
      liEl.innerHTML = templateEl.innerHTML;
      liEl.innerHTML = liEl.innerHTML.replace("{{NAME}}", item.name.fullName);
      liEl.innerHTML = liEl.innerHTML.replace("{{TITLE}}", item.title);
      liEl.innerHTML = liEl.innerHTML.replace("{{NMLS_NUM}}", item.nmlsNum ? `NMLS #${item.nmlsNum}`: '');
      liEl.innerHTML = liEl.innerHTML.replace("{{REGION}}", item.region ?? '')
      liEl.innerHTML = liEl.innerHTML.replace(
        "{{PHONE}}",
        `<a href="tel:${item.phone}">${item.phone}</a>`
      );
      liEl.innerHTML = liEl.innerHTML.replace("{{EMAIL}}", item.email);
      liEl.innerHTML = liEl.innerHTML.replace(
        "{{CONTACT}}",
        `Contact ${item.name.firstName}`
      );

      if (!item.description) {
        liEl.querySelector(".bankercard-bio").innerHTML = "";
      } else {
        liEl.innerHTML = liEl.innerHTML.replace("{{BIO}}", item.description);
      }

      const liLinkEl = liEl.querySelector(".bankercard-cta a[href]");
      const ctaEl = liEl.querySelector(".bankercard-cta a[data-name]");
      const imgEl = liEl.querySelector(".bankercard-img");

      liLinkEl.setAttribute("href", item.url);
      ctaEl.setAttribute("data-name", item.ctaID);
      imgEl.style.backgroundImage = `url(${item.image.url ?? '/wp-content/themes/snb/images/webster-monogram-grey.png'})`;

      liEl.classList.add("bankercard");
      listEl.appendChild(liEl);

      const launchModal = () => {
        const existingModals = document.querySelectorAll(".banker-modal-el");
        const modal = createModal(
          item.name.fullName,
          item.title,
          item.phone,
          item.image.url,
          item.email
        );

        if (existingModals != null && existingModals.length) {
          [].forEach.call(existingModals, (elem) => {
            elem.parentNode.removeChild(elem);
          });
        }
        basicmodal.launch(modal, { className: "bankercard-modal" });
      };

      liEl.querySelector(".banker-cta").addEventListener("click", launchModal);
    }
  };

  const fetchJSON = (pageIndex, callbackFunct) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", `/bankers.json?${getFilterSettings(pageIndex)}`, true);
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 400) {
        callbackFunct(JSON.parse(xhr.response));
      }
    };
    xhr.send();
  };

  const getItems = (pageIndexArg) => {
    // window.scrollBy(0, -400);
    const pageIndex = Number.isInteger(pageIndexArg) ? pageIndexArg : "";
    fetchJSON(pageIndex, outputItems);

    // preload the next page
    setTimeout(() => {
      fetchJSON(pageIndex + 1, () => {});
    }, 2500);
  };

  const closeAllFilters = () => {
    const searchFilter = document.querySelectorAll(".search-filter");

    for (let w = searchFilter.length - 1; w >= 0; w -= 1) {
      if (searchFilter[w].classList.contains("active")) {
        searchFilter[w].classList.remove("active");
      }
    }
  };

  const clickOutsideFilter = () => {
    const popElement = document.querySelectorAll(".search-filter");

    document.addEventListener("click", (event) => {
      for (let q = popElement.length - 1; q >= 0; q -= 1) {
        const popEl = popElement[q];
        const isClickInside = popEl.contains(event.target);
        if (!isClickInside) {
          popEl.classList.remove("active");
        } else {
          break;
        }
      }
    });
  };

  const removeFilterFromList = () => {
    const filters = document.querySelectorAll(".bankergrid-filter");

    document.body.addEventListener("click", (event) => {
      if (event.target.classList.contains("bankergrid-filter-closebtn")) {
        const options = document.querySelectorAll(".forminput-input option");
        const buttons = document.querySelectorAll(".search-filter button");
        let filterVal = event.target.parentElement.classList[1];
        filterVal = filterVal.replace("filterval-", "");

        for (let s = options.length - 1; s >= 0; s -= 1) {
          if (options[s].value === filterVal) {
            options[s].selected = false;

            event.target.parentElement.remove();

            submitBtnEl.click();
          }
        }

        for (let t = options.length - 3; t >= 0; t -= 1) {
          const button = buttons[t];

          if (button.value === filterVal) {
            const filterTitle =
              button.parentElement.previousElementSibling.firstElementChild;
            const categoryTitle =
              button.parentElement.parentElement.previousElementSibling;
            filterTitle.innerHTML = categoryTitle.innerHTML.trim();
          }
        }
      }

      if (event.target.classList.contains("bankergrid-filter-closebtn-name")) {
        inputEl.value = "";

        event.target.parentElement.remove();
        submitBtnEl.click();
      }
    });

    if (filters.length === 0) {
      resultsBanner.style.display = "none";
    }
  };

  const createFiltersList = () => {
    filtersList.innerHTML = "";
    const bankerName = inputEl.value;

    for (let r = selectEls.length - 1; r >= 0; r -= 1) {
      const filterName = document.createElement("div");
      const filterCloseBtn = document.createElement("div");
      const selectEl = selectEls[r];
      const termName =
        selectEl.options[selectEl.selectedIndex].text.toLowerCase();
      const termValue = selectEl.value;

      if (selectEl.selectedIndex !== 0 && selectEl.selectedIndex !== 1) {
        // Exclude "-- Clear --" at index [0] and the dropdown title at index [1]
        if (selectEl.selectedIndex !== selectEl.options.length - 1) {
          filterName.className = `bankergrid-filter filterval-${termValue}`;
          filterName.textContent = termName;
          filterCloseBtn.className = "bankergrid-filter-closebtn";
          filterCloseBtn.textContent = "x";

          filterName.appendChild(filterCloseBtn);
          filtersList.appendChild(filterName);
        }
      }
    }

    if (bankerName !== "") {
      const filterName = document.createElement("div");
      const filterCloseBtn = document.createElement("div");

      filterName.className = `bankergrid-filter filterval-${bankerName}`;
      filterName.textContent = bankerName;
      filterCloseBtn.className = "bankergrid-filter-closebtn-name";
      filterCloseBtn.textContent = "x";
      filterName.appendChild(filterCloseBtn);

      filtersList.appendChild(filterName);
    }

    removeFilterFromList();
  };

  const makeTitle = (slug) => {
    var words = slug.split("-");

    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      words[i] = word.charAt(0).toUpperCase() + word.slice(1);
    }

    return words.join(" ");
  };

  const onDropdownSelect = () => {
    const dropdowns = document.querySelectorAll(
      ".search-filter-category-wrapper"
    );

    for (let u = dropdowns.length - 1; u >= 0; u -= 1) {
      const dropdown = dropdowns[u];
      const dropdownParent = dropdown.parentElement;

      dropdown.addEventListener("click", () => {
        const allDropdowns = document.querySelectorAll(".search-filter");

        if (dropdownParent.classList.contains("active")) {
          dropdownParent.classList.remove("active");
        } else {
          for (let o = allDropdowns.length - 1; o >= 0; o -= 1) {
            if (allDropdowns[o].classList.contains("active")) {
              allDropdowns[o].classList.remove("active");
            }
          }

          dropdownParent.classList.add("active");
        }
      });

      const dropdownChildren = dropdown.nextElementSibling.children;

      for (let v = dropdownChildren.length - 1; v >= 0; v -= 1) {
        dropdownChildren[v].addEventListener("click", () => {
          const dropdownVal = dropdownChildren[v].innerHTML;

          dropdownParent.classList.remove("active");

          if (v !== 0) {
            dropdownChildren[v]
              .closest(".searchfilter-select")
              .previousElementSibling.querySelector(
                ".search-filter-category"
              ).innerHTML = dropdownVal;
          } else {
            const clearAllTitle = makeTitle(dropdownChildren[v].id);
            dropdownChildren[v]
              .closest(".searchfilter-select")
              .previousElementSibling.querySelector(
                ".search-filter-category"
              ).innerHTML = clearAllTitle;
          }
        });
      }
    }
  };

  const searchBarFullWidth = () => {
    const searchEl = document.querySelector(".bankersearch-container");
    const bankerGrid = document.querySelector(".section--bankergrid");

    bankerGrid.insertBefore(searchEl, bankerGrid.firstChild);
  };

  const mobileStyling = () => {
    const mobileBannerExists = document.querySelector(
      ".bankersearch-mobile-banner"
    );

    if (window.innerWidth < 1439) {
      inputEl.placeholder = "Name";
    } else {
      inputEl.placeholder = "";
    }

    if (window.innerWidth < 999) {
      if (!mobileBannerExists) {
        const mobileBanner = document.createElement("div");

        mobileBanner.innerHTML = '<span class="h4">Find a location</span>';
        mobileBanner.className = "bankersearch-mobile-banner";
        document.querySelector(".bankersearch-searchbar").prepend(mobileBanner);
      }
    } else if (mobileBannerExists) {
      mobileBannerExists.remove();
    }
  };

  document.addEventListener("keydown", (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      submitBtnEl.click();
    }
  });

  submitBtnEl.addEventListener("click", (event) => {
    event.preventDefault();
    listEl.innerHTML = "";
    toggleHidden(paginationEl, false);
    toggleHidden(nextEl, false);
    createFiltersList();
    getItems(0);
    closeAllFilters();
  });

  const clickPagination = function (event) {
    const goToPageIndex = Number(event.target.value);
    getItems(goToPageIndex);
  };

  nextEl.addEventListener("click", clickPagination);

  document.addEventListener("DOMContentLoaded", () => {
    searchBarFullWidth();
    getItems();
    onDropdownSelect();
    clickOutsideFilter();
    mobileStyling();

    window.addEventListener("resize", () => {
      mobileStyling();
    });
  });
};

export default bankerSearchWithFilter;
